import { ContentViewModel } from '@levelapp/softfabric';
export default class ResearchInputViewModel extends ContentViewModel {
    constructor(props) {
        super(props);
        this.initialState({ mySearchValue: '' });
        this.handleResetPressed = this.handleResetPressed.bind(this);
        this.handleSearchValueChanged = this.handleSearchValueChanged.bind(this);
    }
    handleSearchValueChanged(searchValue) {
        this.setField({ mySearchValue: searchValue });
        this.props().handlerResearching(searchValue);
    }
    handleResetPressed() {
        this.setField({ mySearchValue: '' });
        this.props().handlingClose();
    }
}
